import type { ConfigSection } from "@warrenio/api-spec/spec.oats.gen";

// cspell:disable
export const adminConfigDataExample: ConfigSection[] = [
    {
        section_key: "api/doc_url",
        data: "https://test-api.pilw.io/",
    },
    {
        section_key: "api/grafana_url",
        data: "https://grafana-test.internal.oye.io",
    },
    {
        section_key: "api/parameters/vm/disks",
        data: {
            min: 20,
            max: 1024,
            limits: [
                {
                    os_name: "windows",
                    min: 40,
                },
                {
                    os_name: "windows_unlicensed",
                    min: 40,
                },
                {
                    os_name: "debian",
                    min: 50,
                },
            ],
        },
    },
    {
        section_key: "api/parameters/vm/ram",
        data: {
            min: 512,
            limits: [
                {
                    os_name: "windows",
                    min: 2048,
                },
                {
                    os_name: "windows_unlicensed",
                    min: 2048,
                },
            ],
        },
    },
    {
        section_key: "api/parameters/vm/vcpu",
        data: {
            is_trashed: true,
            min: 1,
            max: 24,
            limits: [
                {
                    os_name: "windows",
                    min: 2,
                },
                {
                    os_name: "windows_unlicensed",
                    min: 2,
                },
            ],
        },
    },
    {
        section_key: "api/trashed_parameters_vm/disks",
        data: {
            min: 20,
            max: 1024,
            limits: [
                {
                    os_name: "windows",
                    min: 40,
                },
                {
                    os_name: "windows_unlicensed",
                    min: 40,
                },
                {
                    os_name: "debian",
                    min: 50,
                },
            ],
        },
    },
    {
        section_key: "api/trashed_parameters_vm/ram",
        data: {
            min: 512,
            limits: [
                {
                    os_name: "windows",
                    min: 2048,
                },
                {
                    os_name: "windows_unlicensed",
                    min: 2048,
                },
            ],
        },
    },
    {
        section_key: "api/trashed_parameters_vm/vcpu",
        data: {
            is_trashed: true,
            min: 1,
            max: 24,
            limits: [
                {
                    os_name: "windows",
                    min: 2,
                },
                {
                    os_name: "windows_unlicensed",
                    min: 2,
                },
            ],
        },
    },
    {
        section_key: "auth",
        data: [
            {
                section_key: "DEFAULT",
                data: {
                    auth0_domain: "test-warren.io",
                    auth0_client_id: "sdfdsfsfsdfs",
                    auth0_client_secret: "sdfdfdfdsfsdfsdfsdfsdfsdfsdf",
                    mfa_available: 1,
                    management_api_domain: "test.warren.auth0.com",
                    auth0_universal_login: "False",
                },
            },
            {
                section_key: "Warren Demo",
                data: {
                    README: "Intended for test-wrn-warren.io",
                    auth0_domain: "warren.eu.auth0.com",
                    auth0_client_id: "sdfdsfdsfsdfsfsfdsfsfsds",
                    auth0_client_secret: "xeHvl5LZF-sdfsfsdfsfsdfsdfsdfsfsdfsdfdsfsdfsfsdf",
                },
            },
        ],
    },
    {
        section_key: "compute/boot_iso_images_list",
        data: [
            {
                uuid: "e3a5f2d6-7d15-11f0-85ba-047bcbc1cb26",
                image_name: "systemrescue-12.x-amd64.iso",
                is_installation_media: false,
                description: "SystemRescue 12",
                is_published: true,
            },
            {
                uuid: "0bfb622b-eb99-4143-8136-23c247e74434",
                image_name: "boot-repair-disk-64bit.iso",
                is_installation_media: false,
                description: "Boot Repair",
                is_published: false,
            },
            {
                uuid: "70442ea4-0e33-4b4d-bfcd-6154cc183bf9",
                image_name: "Yeastar-P_SOFTWARE-manual-83.20.0.23-debian.iso",
                is_installation_media: true,
                description: "Yeastar-P_SOFTWARE-manual-83.20.0.23-debian",
                is_published: false,
            },
            {
                uuid: "f4dede4d-cc5a-421a-9a29-01f3a5a8617b",
                image_name: "ViciBox_V12.x86_64-12.0.2.iso",
                is_installation_media: true,
                description: "ViciBox_V12.x86_64-12.0.2",
                is_published: false,
            },
            {
                uuid: "8454ab0b-9d15-4a66-bb9e-855dadb21c7a",
                image_name: "netboot.xyz.iso",
                is_installation_media: true,
                description: "netboot.xyz",
                is_published: true,
            },
        ],
    },
    {
        section_key: "compute/limits/vm",
        data: {
            vcpu: 1,
            ram_mb: 2048,
        },
    },
    {
        section_key: "compute/vm_create_time_min_sec",
        data: 6,
    },
    {
        section_key: "config/user/detail_block_fields",
        data: [
            {
                label: "ID number",
                name: "personal_id_number",
                required: 1,
            },
            {
                label: "Phone number",
                name: "phone_number",
                required: 0,
            },
            {
                label: "Contact person name",
                name: "contact_person_name",
                required: 1,
            },
            {
                label: "Contact person's ID number",
                name: "contact_person_id_number",
                required: 1,
            },
        ],
    },
    {
        section_key: "demo_mode/service_package_secrets/d8949586-86a7-4b8d-a44b-4fbd0ec80785",
        data: {
            kubeconfig: "demo",
        },
    },
    {
        section_key: "demo_mode/service_packages",
        data: [
            {
                section_key: "DEFAULT",
                data: null,
            },
        ],
    },
    {
        section_key: "demo_mode/service_packages/team-admin@warren.io",
        data: [
            {
                billing_account_id: 130355,
                created_at: "2024-02-28 07:40:25",
                display_name: "esimene prod",
                is_deleted: false,
                is_multi_node: false,
                prices: [
                    {
                        priceMultiplier: 1.6,
                        resourceType: "CPU",
                    },
                    {
                        priceMultiplier: 1.6,
                        resourceType: "RAM",
                    },
                    {
                        priceMultiplier: 1.6,
                        resourceType: "STORAGE",
                        serviceNameInUptime: "main",
                    },
                    {
                        priceMultiplier: 1.6,
                        resourceType: "STORAGE",
                        serviceNameInUptime: "block",
                    },
                    {
                        priceMultiplier: 0.0,
                        resourceType: "STORAGE",
                        serviceNameInUptime: "snapshot",
                    },
                    {
                        priceMultiplier: 0.0,
                        resourceType: "STORAGE",
                        serviceNameInUptime: "backup",
                    },
                    {
                        priceMultiplier: 0.0,
                        resourceType: "OBJECT_STORAGE",
                    },
                    {
                        priceMultiplier: 0.0,
                        resourceType: "LICENSE",
                        serviceNameInUptime: "windows",
                    },
                    {
                        priceMultiplier: 0.0,
                        resourceType: "UNASSIGNED_FLOATING_IP",
                    },
                    {
                        price_multiplier: 1.6,
                        resource_type: "CPU",
                    },
                    {
                        price_multiplier: 1.6,
                        resource_type: "RAM",
                    },
                    {
                        price_multiplier: 1.6,
                        resource_type: "BLOCK_STORAGE",
                    },
                    {
                        price_multiplier: 0.0,
                        resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    },
                    {
                        price_multiplier: 0.0,
                        resource_type: "BLOCK_STORAGE_BACKUP",
                    },
                    {
                        price_multiplier: 0.0,
                        resource_type: "OBJECT_STORAGE",
                    },
                    {
                        price_multiplier: 0.0,
                        resource_type: "WINDOWS_LICENSE",
                    },
                    {
                        price_multiplier: 0.0,
                        resource_type: "LOAD_BALANCER",
                    },
                    {
                        price_multiplier: 0.0,
                        resource_type: "UNASSIGNED_FLOATING_IP",
                    },
                ],
                properties: {
                    location: "tll01",
                    cluster_name: "240228d8949586",
                    spec: {
                        hibernation: {
                            enabled: false,
                        },
                        kubernetes: {
                            kubeAPIServer: {
                                requests: {
                                    maxNonMutatingInflight: 400,
                                    maxMutatingInflight: 200,
                                },
                                enableAnonymousAuthentication: false,
                                eventTTL: "1h0m0s",
                                logging: {
                                    verbosity: 2,
                                },
                                defaultNotReadyTolerationSeconds: 300,
                                defaultUnreachableTolerationSeconds: 300,
                            },
                            kubeControllerManager: {
                                nodeCIDRMaskSize: 24,
                                nodeMonitorGracePeriod: "2m0s",
                            },
                            kubeScheduler: {
                                profile: "balanced",
                            },
                            kubeProxy: {
                                mode: "IPTables",
                                enabled: true,
                            },
                            kubelet: {
                                failSwapOn: true,
                                kubeReserved: {
                                    cpu: "80m",
                                    memory: "1Gi",
                                    pid: "20k",
                                },
                                imageGCHighThresholdPercent: 50,
                                imageGCLowThresholdPercent: 40,
                                serializeImagePulls: true,
                            },
                            version: "1.26.13",
                            verticalPodAutoscaler: {
                                enabled: true,
                                evictAfterOOMThreshold: "10m0s",
                                evictionRateBurst: 1,
                                evictionRateLimit: -1,
                                evictionTolerance: 0.5,
                                recommendationMarginFraction: 0.15,
                                updaterInterval: "1m0s",
                                recommenderInterval: "1m0s",
                            },
                            enableStaticTokenKubeconfig: true,
                        },
                        maintenance: {
                            autoUpdate: {
                                kubernetesVersion: true,
                                machineImageVersion: false,
                            },
                            timeWindow: {
                                begin: "030000+0200",
                                end: "040000+0200",
                            },
                        },
                        networking: {
                            type: "calico",
                            providerConfig: {
                                apiVersion: "calico.networking.extensions.gardener.cloud/v1alpha1",
                                kind: "NetworkConfig",
                                typha: {
                                    enabled: false,
                                },
                            },
                            pods: "10.1.0.0/16",
                            nodes: "10.125.191.0/24",
                            services: "10.2.0.0/16",
                            ipFamilies: ["IPv4"],
                        },
                        provider: {
                            type: "warren",
                            controlPlaneConfig: {
                                apiEndpointURL: "https://api.pilvio.com/v1/tll01",
                                apiVersion: "warren.provider.extensions.gardener.cloud/v1alpha1",
                                kind: "ControlPlaneConfig",
                                zone: "tll01",
                            },
                            infrastructureConfig: {
                                apiEndpointURL: "https://api.pilvio.com/v1/tll01",
                                apiVersion: "warren.provider.extensions.gardener.cloud/v1alpha1",
                                kind: "InfrastructureConfig",
                                networks: {
                                    workersConfiguration: {
                                        zone: "tll01",
                                    },
                                },
                            },
                            workers: [
                                {
                                    cri: {
                                        name: "containerd",
                                    },
                                    name: "keskmised",
                                    machine: {
                                        image: {
                                            name: "ubuntu",
                                            version: "22.04",
                                        },
                                        architecture: "amd64",
                                        vcpu: 2,
                                        ram: 4096,
                                    },
                                    maximum: 2,
                                    minimum: 1,
                                    maxSurge: 1,
                                    maxUnavailable: 0,
                                    volume: {
                                        size: "40Gi",
                                    },
                                    zones: ["tll01"],
                                    systemComponents: {
                                        allow: true,
                                    },
                                },
                            ],
                            workersSettings: {
                                sshAccess: {
                                    enabled: true,
                                },
                            },
                        },
                    },
                    status: {
                        conditions: [
                            {
                                type: "APIServerAvailable",
                                status: "True",
                                lastTransitionTime: "2024-03-13T01:01:59Z",
                                lastUpdateTime: "2024-03-13T01:01:59Z",
                                reason: "HealthzRequestSucceeded",
                                message: "API server /healthz endpoint responded with success status code.",
                            },
                            {
                                type: "ControlPlaneHealthy",
                                status: "True",
                                lastTransitionTime: "2024-03-12T21:38:02Z",
                                lastUpdateTime: "2024-03-12T21:38:02Z",
                                reason: "ControlPlaneRunning",
                                message: "All control plane components are healthy.",
                            },
                            {
                                type: "ObservabilityComponentsHealthy",
                                status: "Progressing",
                                lastTransitionTime: "2024-03-13T08:19:49Z",
                                lastUpdateTime: "2024-03-12T21:14:49Z",
                                reason: "DeploymentMissing",
                                message: "Missing required deployments: [kube-state-metrics]",
                            },
                            {
                                type: "EveryNodeReady",
                                status: "True",
                                lastTransitionTime: "2024-03-13T01:01:59Z",
                                lastUpdateTime: "2024-03-13T01:01:59Z",
                                reason: "EveryNodeReady",
                                message: "All nodes are ready.",
                            },
                            {
                                type: "SystemComponentsHealthy",
                                status: "Progressing",
                                lastTransitionTime: "2024-03-13T08:19:49Z",
                                lastUpdateTime: "2024-03-13T08:19:19Z",
                                reason: "DeploymentUnhealthy",
                                message:
                                    'Deployment "kube-system/vpn-shoot" is unhealthy: condition "Available" has invalid status False (expected True) due to MinimumReplicasUnavailable: Deployment does not have minimum availability.',
                            },
                        ],
                        constraints: [
                            {
                                type: "HibernationPossible",
                                status: "True",
                                lastTransitionTime: "2024-03-13T01:01:59Z",
                                lastUpdateTime: "2024-03-13T01:01:59Z",
                                reason: "NoProblematicWebhooks",
                                message: "All webhooks are properly configured.",
                            },
                            {
                                type: "MaintenancePreconditionsSatisfied",
                                status: "True",
                                lastTransitionTime: "2024-03-13T01:01:59Z",
                                lastUpdateTime: "2024-03-13T01:01:59Z",
                                reason: "NoProblematicWebhooks",
                                message: "All webhooks are properly configured.",
                            },
                        ],
                        gardener: {
                            id: "wvyJGWkJwPxhAOlY5BouZXeJ8fNs762786yBFo97FS7ZfCpxyMgIZpAqxzcRmjA9",
                            name: "gardenlet-57dfc57f88-5wtm5",
                            version: "v1.87.3",
                        },
                        hibernated: false,
                        lastOperation: {
                            description:
                                'Flow "Shoot cluster reconciliation" encountered task errors: [task "Deploying shoot system resources" failed: retry failed with context deadline exceeded, last error: failed to discover the API: unable to retrieve the complete list of server APIs: metrics.k8s.io/v1beta1: the server is currently unable to handle the request] Operation will be retried.',
                            lastUpdateTime: "2024-03-13T08:03:38Z",
                            progress: 92,
                            state: "Error",
                            type: "Create",
                        },
                        observedGeneration: 3,
                        retryCycleStartTime: "2024-03-13T01:32:22Z",
                        seedName: "local",
                        technicalID: "shoot--local--240228d8949586",
                        uid: "71624f5c-3627-475e-bbb8-d0f036c7ffda",
                        clusterIdentity:
                            "shoot--local--240228d8949586-71624f5c-3627-475e-bbb8-d0f036c7ffda-garden-cluster-identity",
                        advertisedAddresses: [
                            {
                                name: "external",
                                url: "https://api.240228d8949586.local.external.prod.pilw.gardendev.wrrnk8s.com",
                            },
                            {
                                name: "internal",
                                url: "https://api.240228d8949586.local.internal.ingress.local.prod.pilw.gardendev.wrrnk8s.com",
                            },
                        ],
                        lastErrors: [
                            {
                                description:
                                    'task "Deploying shoot system resources" failed: retry failed with context deadline exceeded, last error: failed to discover the API: unable to retrieve the complete list of server APIs: metrics.k8s.io/v1beta1: the server is currently unable to handle the request',
                                taskID: "Deploying shoot system resources",
                                lastUpdateTime: "2024-03-13T08:03:38Z",
                            },
                        ],
                        lastMaintenance: {
                            description:
                                'All maintenance operations successful. Worker pool "keskmised": Updated machine image "ubuntu" from "22.04.01" to "24.04". Reason: Automatic update of the machine image version is configured (image update strategy: major)',
                            triggeredTime: "2024-03-09T01:23:20Z",
                            state: "Succeeded",
                        },
                    },
                },
                resources: [
                    {
                        resource_allocation: {},
                        resource_id: "16840",
                        resource_type: "kong_token",
                    },
                    {
                        resource_allocation: {},
                        resource_id: "c7bc91b2-f940-4f47-8be6-881a275f1fbf",
                        resource_location: "tll01",
                        resource_type: "network",
                    },
                ],
                service: "kubernetes",
                status: "active",
                updated_at: "2024-03-13 08:10:42",
                user_id: 14,
                uuid: "d8949586-86a7-4b8d-a44b-4fbd0ec80785",
                version: "1.26.13",
            },
            "append_real",
        ],
    },
    {
        section_key: "email/smtp",
        data: {
            hostname: "smtp.gmail.com",
            password: "qwerty",
            port: 587,
            username: "admin@warren.io",
            tls: true,
        },
    },
    {
        section_key: "location_services/tll",
        data: [
            {
                service: "OBJECT_STORAGE",
                enabled: true,
            },
        ],
    },
    {
        section_key: "locations/jhv",
        data: {
            display_name: "Jõhvi",
            is_preferred: false,
            is_published: true,
            description: "The original",
            country_code: "SWE",
            order_nr: 0,
            create_resource_disabled: false,
            slug: "jhv",
        },
    },
    {
        section_key: "locations/tll",
        data: {
            display_name: "Tallinn",
            is_preferred: true,
            is_published: true,
            description: "New DC in Tallinn",
            country_code: "EST",
            order_nr: 2,
            create_resource_disabled: false,
        },
    },
    {
        section_key: "network/fip_limits",
        data: {
            generic_unassigned_limit: 15,
            account_limits: [
                {
                    billing_account_id: 130079,
                    unassigned_limit: 3,
                },
            ],
        },
    },
    {
        section_key: "network/iftune",
        data: {
            average_kbps: 0,
            peak_kbps: 0,
            burst_kb: 0,
        },
    },
    {
        section_key: "payment/account_validation",
        data: {
            process: "EXTERNAL",
            provider: "digio",
            test_mode: 1,
            provider_conf: {
                client_id: "ACK250328121518217611XHF11LIA8YE",
                workflow_name: "demo_simple",
                workflow_name_by_country: {
                    ee: "demo_simple_ee",
                    ru: "demo_simple_ru",
                },
                notify_customer: 1,
                auto_accept: 1,
                whitelist_ips: ["35.154.20.28", "13.126.198.236"],
            },
        },
    },
    {
        section_key: "payment/add_payment_method_later",
        data: true,
    },
    {
        section_key: "payment/allow_debt",
        data: false,
    },
    {
        section_key: "payment/billing_account_fields",
        data: [
            {
                field: "email",
                required: true,
            },
            {
                field: "address_line1",
                required: true,
            },
            {
                field: "city",
                required: true,
            },
            {
                field: "company_name",
                required: true,
                validator: {
                    type: "for_testing",
                },
            },
            {
                field: "company_reg_code",
                required: false,
                validator: {
                    type: "for_testing",
                },
            },
            {
                field: "company_vat_number",
                required: false,
            },
            {
                field: "country",
                required: true,
            },
            {
                field: "county",
                required: true,
            },
            {
                field: "customer_name",
                required: false,
            },
            {
                field: "customer_phone",
                required: false,
            },
            {
                field: "customer_id_number",
                required: false,
                visible: false,
            },
            {
                field: "post_index",
                required: true,
            },
        ],
    },
    {
        section_key: "payment/billing_account_fields_config",
        data: {
            address_fields_required: 1,
            customer_name_required: 0,
            company_fields_required: 1,
            document_upload_required: 0,
            customer_phone_shown: 1,
        },
    },
    {
        section_key: "payment/currency",
        data: "EUR",
    },
    {
        section_key: "payment/default_active_post_payment_level",
        data: "LIMITED",
    },
    {
        section_key: "payment/document_prefixes",
        data: {
            invoice: "#",
            report: "RP-",
            credit_note: "CN-",
        },
    },
    {
        section_key: "payment/first_account_credit",
        data: 12.0,
    },
    {
        section_key: "payment/low_balance_threshold",
        data: 22,
    },
    {
        section_key: "payment/min_topup_amount",
        data: 5.0,
    },
    {
        section_key: "payment/recurring",
        data: true,
    },
    {
        section_key: "payment/referral_code",
        data: true,
    },
    {
        section_key: "payment/referral_credit_amounts",
        data: [
            {
                section_key: "DEFAULT",
                data: {
                    promoter_credit: 1,
                    receiver_credit: 2,
                    receiver_precondition_topup_sum: 1,
                },
            },
        ],
    },
    {
        section_key: "payment/restriction_level_clear_topup_threshold",
        data: 22,
    },
    {
        section_key: "payment/restriction_level_thresholds",
        data: [
            {
                days: 20,
                restriction_level: "FROZEN",
            },
            {
                days: 12,
                restriction_level: "TERMINATED",
            },
        ],
    },
    {
        section_key: "payment/theme_conf/DEFAULT",
        data: {
            sender: {
                name: "Warren",
                email: "hello@warren.io",
            },
            timezone: "Europe/Tallinn",
            title: "Warren",
            ui_url: "https://demo.warren.io",
            logo_url: "https://demo.warren.io/hub/static/themes/warren/logo-email.png",
            email: "billing@warren.io",
            invoice_payment_notice_email: "user@warren.io",
            primary_color: "#253AF3",
            company: {
                name: "Warren OÜ",
                address: "Telliskivi 57, 10412 Tallinn, Estonia",
                reg_number: "12626294",
                vat_number: "EE101709080",
                raw: {
                    html: "",
                    text: "",
                },
            },
            bank: {
                name: "Demo Pank",
                address: "Tartu mnt 2, 10145 Tallinn, Estonia",
                iban: "EE77776666677777888",
                swift: "BNKBEE66",
                raw: {
                    html: "",
                    text: "",
                },
            },
            formats: {
                record_amounts: "{0:.6f}",
                total_amounts: "{0:.2f}",
                mon_decimal_point: ",",
            },
            invoice_alt_name: "Order",
        },
    },
    {
        section_key: "payment/translations/en",
        data: {
            PDF: {
                INVOICE_HEADER: {
                    INVOICE_NAME: "Order {document_number}",
                    INVOICE_ID_TEXT__INVOICE: "Order {document_number}",
                },
                ACCOUNT_TOTAL_UNPAID: "Total due including all unpaid orders",
            },
            PAYMENT_HELP_TEXT__NOT_BY_CARD: "",
            PAYMENT_HELP_TEXT__CREDIT_TOPUP: "",
            MAIL_INTRO__INVOICE: "Your order {document_number} for billing account {account_name} is now available.",
            DESCRIPTION__POST_PAYMENT:
                "PDF order with usage report is attached to this email and can also be found under your billing account.",
            DESCRIPTION__CREDIT_TOPUP:
                "PDF order is attached to this email and can also be found under your billing account.",
        },
    },
    {
        section_key: "payment/translations/fi",
        data: {
            PDF: {
                INVOICE_HEADER: {
                    BILLING_ACCOUNT: "Laskutustili FI",
                },
            },
        },
    },
    {
        section_key: "payment/translations/zh-TW",
        data: {
            PDF: {
                INVOICE_HEADER: {
                    BILLING_ACCOUNT: "Billing account CHINA",
                },
            },
        },
    },
    {
        section_key: "payment/processors/DEFAULT",
        data: [
            {
                type: "creditcard",
                name: "PayPal (Warren Sandbox)",
                keyword: "paypal_vault",
                is_test: 1,
                verification_amount: 100,
                client_id: "fsdfSDFSDDGFdfgsdddfsdfFSDfsdfsdfsdfds",
            },
            {
                type: "link",
                name: "Coingate",
                keyword: "coingate",
                is_test: "yes",
                methods: [
                    {
                        key: "coingate",
                        name: "Coingate",
                    },
                ],
            },
            {
                type: "link",
                name: "ClicToPay",
                keyword: "clictopay",
                is_test: "yes",
                username: "dfsdfsdfsdfd",
                methods: [
                    {
                        key: "clictopay",
                        name: "ClicToPay",
                    },
                ],
            },

            {
                type: "link",
                name: "Wallets",
                keyword: "stripe_wallet",
                public_key: "sdfsdfssddhjbfdhjfbidsuyvdfusyddsbdshdbsabdajsda",
                methods: [
                    {
                        key: "alipay",
                        name: "Alipay (Stripe Wallet)",
                    },
                    {
                        key: "grabpay",
                        name: "GrabPay (Stripe Wallet)",
                    },
                    {
                        key: "wechat_pay",
                        name: "WeChat Pay (Stripe Wallet)",
                    },
                ],
                charge_currency_conversion: {
                    to_currency: "USD",
                    exchange_rate: 1.4450908,
                },
                service_fee: {
                    flat_rate: 10,
                    percentage: 3.4,
                },
            },
        ],
    },
    {
        section_key: "payment/vat",
        data: [
            {
                section_key: "DEFAULT",
                data: 10,
            },
            {
                section_key: "EE",
                data: 24,
            },
        ],
    },

    {
        section_key: "services/resources_purge_interval_secs",
        data: 10,
    },
    {
        section_key: "storage/disks_trashing/bypass_trash_younger_than_hours",
        data: 2,
    },
    {
        section_key: "storage/disks_trashing/cooldown_after_rbd_rm_seconds",
        data: 10,
    },
    {
        section_key: "storage/disks_trashing/keep_in_trash_days",
        data: 1,
    },
    {
        section_key: "storage/iotune",
        data: {
            average_kbps: 10240,
            peak_kbps: 20480,
            burst_kb: 5120,
        },
    },
    {
        section_key: "storage/windows/resize_partition_number",
        data: 2,
    },
    {
        section_key: "test/api/doc_url",
        data: "https://test-api.pilw.io/",
    },
    {
        section_key: "test/api/kas_kustun",
        data: 123,
    },
    {
        section_key: "test/payment/billing_account_fields",
        data: [
            {
                field: "email",
                required: true,
            },
            {
                field: "address_line1",
                required: false,
            },
            {
                field: "city",
                required: false,
            },
            {
                field: "company_name",
                required: false,
            },
            {
                field: "company_reg_code",
                required: false,
            },
            {
                field: "company_vat_number",
                required: false,
            },
            {
                field: "country",
                required: false,
            },
            {
                field: "county",
                required: false,
            },
            {
                field: "customer_name",
                required: false,
            },
            {
                field: "customer_phone",
                required: false,
            },
            {
                field: "customer_id_number",
                required: false,
                visible: false,
            },
            {
                field: "post_index",
                required: false,
            },
        ],
    },
    {
        section_key: "test/ui/country",
        data: "EE",
    },
    {
        section_key: "test/ui/locale",
        data: "et-EE",
    },
    {
        section_key: "test/ui/private_networks_enabled",
        data: true,
    },
    {
        section_key: "test/ui/services_enabled",
        data: true,
    },
    {
        section_key: "test/ui/site_theme",
        data: "Warren Light",
    },
    {
        section_key: "test/ui/storage_enabled",
        data: true,
    },
    {
        section_key: "test/ui/timezone",
        data: "Europe/Tallinn",
    },
    {
        section_key: "test/ui/vm_apps_enabled",
        data: true,
    },
    {
        section_key: "theme/css_vars",
        data: {
            "--primary-color": "38, 131, 255",
            "--secondary-color": "229, 229, 229",
            "--color-1": "242, 242, 242",
            "--color-2": "229, 229, 229",
            "--color-3": "211, 211, 211",
            "--color-4": "128, 128, 128",
            "--color-5": "9, 27, 37",
            "--gray-1": "247, 247, 247",
            "--error": "211, 0, 33",
            "--success": "0, 147, 69",
        },
    },
    {
        section_key: "theme/props",
        data: {
            login_logo:
                "data:image/svg+xml;base64,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",
            theme_title: "MaxCloud",
            login_title: "Täitsa hästi - ",
            login_quote: "Töötab",
            login_sub: "Blaa blaa blaa Blaa blaa blaa Blaa blaa blaa",
            theme_home_welcome: "Welcome to MaxCloud!",
            theme_home_sub:
                "In order to keep MaxCloud a safe and sustainable platform, we require new members to give away a bit of information.",
            theme_home_hold:
                "You may see a temporary authorization hold on your card, witch your bank should release soon.",
            theme_terms: "By signing up, you agree to the <a href='#' target='_blank'>Terms of Service</a>",
            theme_credit_card_validation_explanation: "",
            onboarding_by_selecting_credit_card:
                "By selecting Credit Card as the payment method you will be able to access the platform in a few moments after we have verified your card. You may see a temporary pre-authorization charge on your card which will be reversed later. MaxCloud credit card payments are processed by Stripe.",
        },
    },
    {
        section_key: "ui/backup_time",
        data: "Every now and then",
    },
    {
        section_key: "ui/bare_metal_enabled",
        data: true,
    },
    {
        section_key: "ui/chat",
        data: {
            type: "intercom",
            intercom_app_id: "xafgkrwj",
        },
    },
    {
        section_key: "ui/chat__secret",
        data: null,
    },
    {
        section_key: "ui/clarity_key",
        data: null,
    },
    {
        section_key: "ui/country",
        data: "EE",
    },
    {
        section_key: "ui/currencies",
        data: [
            { code: "USD", title: "USD", rate: 1 },
            { code: "AUD", title: "AUD", rate: 1.53 },
            { code: "EUR", title: "EUR", rate: 0.86 },
        ],
    },
    {
        section_key: "ui/default_language",
        data: "en",
    },
    {
        section_key: "ui/disks_enabled",
        data: true,
    },
    {
        section_key: "ui/facebook_pixel_id",
        data: 3238104059821375,
    },
    {
        section_key: "ui/firewall_enabled",
        data: true,
    },
    {
        section_key: "ui/google_analytics_key",
        data: "G-WMBFL56KLX",
    },
    {
        section_key: "ui/google_analytics_key_test",
        data: "G-RKDRGLHMVY",
    },
    {
        section_key: "ui/google_tag_manager_key",
        data: [
            {
                section_key: "DEFAULT",
                data: "GTM-WZSJSQSQ",
            },
        ],
    },
    {
        section_key: "ui/kubernetes_enabled",
        data: true,
    },
    {
        section_key: "ui/language",
        data: "id-ID",
    },
    {
        section_key: "ui/linkedin_conversion_id",
        data: null,
    },
    {
        section_key: "ui/linkedin_partner_id",
        data: null,
    },
    {
        section_key: "ui/load_balancer_enabled",
        data: true,
    },
    {
        section_key: "ui/locale",
        data: "en-GB",
    },
    {
        section_key: "ui/localizejs_key",
        data: null,
    },
    {
        section_key: "ui/login_subtitle",
        data: "Login please",
    },
    {
        section_key: "ui/login_title",
        data: "Welcome!",
    },
    {
        section_key: "ui/multi_language",
        data: false,
    },
    {
        section_key: "ui/new_ui_active",
        data: 0,
    },
    {
        section_key: "ui/predefined_packages/vm",
        data: [
            {
                cpu: 1,
                ram: 1,
                ssd: 5,
                default: [],
                os: ["other"],
                disabled: [],
            },
            {
                cpu: 2,
                ram: 1,
                ssd: 20,
                default: ["other"],
                os: ["other"],
            },
            {
                cpu: 2,
                ram: 2,
                ssd: 50,
                default: [],
                os: ["other", "win"],
                notice: "Special offer",
            },
            {
                cpu: 2,
                ram: 4,
                ssd: 60,
                default: ["win"],
                os: ["other", "win"],
            },
            {
                cpu: 14,
                ram: 4,
                ssd: 80,
                default: [],
                os: ["win"],
            },
        ],
    },
    {
        section_key: "ui/private_networks_enabled",
        data: true,
    },
    {
        section_key: "ui/s3_force_path_style",
        data: false,
    },
    {
        section_key: "ui/services_enabled",
        data: true,
    },
    {
        section_key: "ui/site_name",
        data: "Warren test test",
    },
    {
        section_key: "ui/site_theme",
        data: "pilvio",
    },
    {
        section_key: "ui/storage_enabled",
        data: true,
    },
    {
        section_key: "ui/support_email",
        data: "invoice@warren.io",
    },
    {
        section_key: "ui/support_link_url",
        data: "https://warren.io/support",
    },
    {
        section_key: "ui/terms/DEFAULT",
        data: {
            url: "//3nv.io/terms-of-service",
        },
    },
    {
        section_key: "ui/vm_apps_enabled",
        data: true,
    },
];
// cspell:enable
